import { useQuery, useMutation } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

interface BillingData {
  minutesBalance: {
    usd_balance: number
    month_minutes: number
    updated: string | null
  }
  stripeCustomer: {
    stripeCustomerId: string | null
  }
}

export function useBilling() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['billing'],
    queryFn: async () => {
      return apiClient<BillingData>('/billing')
    },
  })
}

export function useManageSubscription() {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async () => {
      return  apiClient<{ url: string }>('/billing', {
        method: 'POST',
      })
    },
    onSuccess: (result) => {
      // Redirect to Stripe portal
      if (result.url) {
        window.location.href = result.url
      }
    },
    onError: (error) => {
      console.error('Error managing subscription:', error)
    },
  })
}